export enum VoiceMessageSlot {
  CallNotConnected = "call-not-connected",
  QueueWaiting = "queue-waiting",
  QueueConnecting = "queue-connecting",
  CallRecordingNotice = "call-recording-notice",
  VoicemailGreeting = "voicemail-greeting",
}
